import EventBus from '../../../shared/js/wirebox/event-bus'
import '../../../shared/js/wirebox/components/location-autocomplete'
import '../../../shared/js/wirebox/utilities/get-hidden-input'
import jQuery from 'jquery'

const AddressInputs = {
    
    /**
     * Process address autocomplete
     * @param input
     * @param address
    */
    process(input, place) {

        var
            attributes = {},
            hash = {}
            
        //Loop through place's address components and construct hash
        jQuery.each(place.address_components, (i, component) => {
            jQuery.each(component.types, (ti, type) => {
                hash[type] = component.long_name
            })
        })

        //Define address values from hash

        attributes.city = hash.hasOwnProperty('postal_town') ? hash.postal_town : (hash.hasOwnProperty('locality') ? hash.locality : hash.hasOwnProperty('sublocality_level_1') ? hash.sublocality_level_1 : null)
        attributes.country = hash.hasOwnProperty('country') ? hash.country : null
        attributes.line_1 = (hash.hasOwnProperty('street_number') ? (hash.street_number + ' ') : '') + (hash.hasOwnProperty('route') ? hash.route : '')
        //attributes.line_2 = hash.hasOwnProperty('postal_town') ? hash.postal_town : null
        attributes.latitude = place.geometry.location.lat()
        attributes.longitude = place.geometry.location.lng()
        
        let
            isUk = attributes.country == 'United Kingdom',
            stateLevel = isUk ? 2 : 1,
            stateKey = 'administrative_area_level_' + stateLevel
        
        attributes.state = hash.hasOwnProperty(stateKey) ? hash[stateKey] : null
        attributes.zip_code = hash.hasOwnProperty('postal_code') ? hash.postal_code : null

        //Create hidden inputs
        jQuery.each(attributes, (key, value) => {
            EventBus.publish('get-hidden-input', {
                callback: (hiddenInput) => {
                    hiddenInput.val(value)
                },
                input: input,
                name: 'address[' + key + ']'
            })
        })
        
        //Show Address modal
        input.siblings('label').first().find('button').click()
        
    },
    
    /**
     * Process input change
     * @param event
    */
    handleChange(event) {
        
        let changed = jQuery(event.target)
        if (changed.val().length > 0) {
            return
        }
        
        let
            input
        
        //Clear related hidden inputs
        changed.siblings('input[type="hidden"]').each((i, element) => {
            
            input = jQuery(element)
            
            if (input.attr('name').startsWith('address[')) {
                input.val('')
            }
            
        })
        
    },
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Place updated
        jQuery(document).on('location-autocompleted', '.add-address-inputs', (event, address) => {
            this.process(jQuery(event.target), address)
        })
        
        //Listener to handle address being emptied
        .on('change', '.add-address-inputs', this.handleChange.bind(this))
        
    }
    
}

AddressInputs.bindEvents()

export default AddressInputs